<template>

  <ion-page id="startasr-page">
    <ion-content>
      <TopLine :style="styleTopline" :showDone="showDone" :showMute="showMute" title="Verbal Chess"/>
      <ion-list :style="styleMiddle">
        <ion-item>
        <ion-label class="ion-text-wrap">
          <h1>{{ recognizerDownloadStatus }}</h1>
          <h3>{{ recognizerDownloadStatus2 }}</h3>
          <div v-show="showDownloadingNotes">
          <p><i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ noteAboutDownloadSize }}</i>
            {{ downloadOnceString }}</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ timeDownloadingString }}: {{ timerAmount }} {{ secondsString }}</p>
          </div>
          <div v-show="showNeedMicrophoneAccess">
          <p><b>{{ noteAboutMicrophoneNotRecording }}</b></p> 
          </div>
        </ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-page>
</template>

<script setup>

import { IonPage, IonContent,IonList,IonItem,IonLabel , IonButton } from '@ionic/vue';

import { isPlatform, getPlatforms } from '@ionic/vue';
import { computed } from "@vue/reactivity"

import { ref, watch } from 'vue'
import ToolBar from '@/components/ToolBar.vue'
import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';

import { doStartupCheck } from '@/composables/startupCheck.js'
import TopLine from '@/components/TopLine.vue'
import { voiceAddMicrophoneSupport } from '@/composables/voicesSupport.js'

import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight } from '@/composables/screenSize'
import { translateEnglishWords, translateForeignWords, translatePhrase } from '@/composables/translation';

const emit = defineEmits(['where-next'])

const props = defineProps({
      startASRStatus : {
        type : String,
        default : ""
      },
      startASRStatusTrigger : {
        type : Number,
        default : 0
      }
    })

const startASRStatus = computed({get() {return props.startASRStatus}})
const startASRStatusTrigger = computed({get() {return props.startASRStatusTrigger}})

const connectionStore = useConnectionStore()
const windowSizeStore = useWindowSizeStore()

const wordlistStartASR = "test dog cat"
const wordlistTrigger = ref(0)

const showDone = ref(false)
const showMute= ref(false)
const asrReady = ref(false)

const platforms = getPlatforms()
console.log("***** platforms ",platforms)
const isIOS = isPlatform("ios")
//isIOS.value = true
const isAndroid = isPlatform("android")
const isMobile = isPlatform("mobile")

console.log("PLATFORMS ",isIOS,isAndroid,isMobile)

const secondsString = ref(translateEnglishWords("seconds"))
const timeDownloadingString = ref(translatePhrase("Time downloading"))
const downloadOnceString = ref(translatePhrase("Downloading could take a few seconds, possibly up to 30 seconds. Once downloaded, it will be available instantly in the future."))
const noteAboutDownloadSize = ref(translatePhrase("Note: the speech recognition language model is 41 megabytes."))
const noteAboutMicrophoneNotRecording = ref(translatePhrase("Note: speech recognition needs access to the microphone. Nothing is recorded or saved."))
const iosButton = ref(translatePhrase("For IOS & Android, Click Button to Initialize the Audio System"))
const recognizerDownloadStatus = ref(translatePhrase("Initializing Speech Recognizer"))
const recognizerDownloadStatus2 = ref(translatePhrase("Downloading Language Model"))
const showDownloadingNotes = ref(true)
const showNeedMicrophoneAccess = ref(true)

const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)

const wordlist = ref(wordlistStartASR)

var timerCanStop = false
const timerAmount = ref(0)

const welcomeMessageSaid = false

// speaking

var voices = []
var engineVoiceNumber = -1
var playerVoiceNumber = -1

 watch(startASRStatusTrigger, (newVal,oldVal) => {
    console.log('*********** start ASR Status ',newVal,props.startASRStatus)
    processStatus(props.startASRStatus)
  })

 watch(() => windowSizeStore.getWindowSize, () => {
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
  })

function processStatus(status) {
  switch (status) {
    case "downloading" :
      startTimer()
      break
    case "downloaded" :
      timerCanStop = true
      showDownloadingNotes.value = false
      recognizerDownloadStatus2.value = translatePhrase("Waiting on Microphone Access")
      break
    case "mic" :
      timerCanStop = true
      showDownloadingNotes.value = false
      showNeedMicrophoneAccess.value = false

      recognizerDownloadStatus2.value = translatePhrase("Got Microphone Access")
      break
    case "no_mic" :
      timerCanStop = true
      showDownloadingNotes.value = false
      showNeedMicrophoneAccess.value = false

      recognizerDownloadStatus2.value = "*** " + translatePhrase("No Microphone Access. Click & Tap still works.")
      const timeoutId = setTimeout(emit("where-next","/main_or_urlaction"), 3000);

      break
    case "ready" :
      timerCanStop = true
      showDownloadingNotes.value = false
      showNeedMicrophoneAccess.value = false
      recognizerDownloadStatus2.value = translatePhrase("Got Microphone Access")
      emit("where-next","initAudio")
      break
    case "audioDone" :
      timerCanStop = true
      showDownloadingNotes.value = false
      showNeedMicrophoneAccess.value = false
      recognizerDownloadStatus2.value = translatePhrase("Got Microphone Access")
      connectionStore.setAudioCanBeHeard(false)
      emit("where-next","/main_or_urlaction")
      break
    }
 }

 function sendInitAudio() {
    emit("where-next","initAudio")
 }

  // https://stackoverflow.com/questions/12489546/getting-a-browsers-name-client-side

function getBrowserName() {
  const agent = window.navigator.userAgent.toLowerCase();
  const browser =
      agent.indexOf('edge') > -1 ? 'edge'
      : agent.indexOf('edg') > -1 ? 'chromium based edge'
      : agent.indexOf('opr') > -1 && window.opr ? 'opera'
      : agent.indexOf('chrome') > -1 && window.chrome ? 'chrome'
      : agent.indexOf('trident') > -1 ? 'ie'
      : agent.indexOf('firefox') > -1 ? 'firefox'
      : agent.indexOf('safari') > -1 ? 'safari'
      : 'other';

  //console.log(`*********************   ${agent}\n${browser}`);
  return (browser)
}

function parseCommands(words,currentWordIndex) {
  
  //console.log("in parse commands",words,currentWordIndex)
  var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
  var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
  var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

  for (var i = 0; i < words.length; i++) {
      if (currentWord == "ignore") {
          return ["ignore",""];
      }
      if (currentWord == "listen") {
        return ["listen",""]
      }
      if (currentWord == "mute") {
        return ["mute",""]
      }
      
      if (currentWord == "done") {
          return ["done",""]
      }

      currentWord = nextWord;
      nextWord = nextNextWord;
      nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
  }
  return ["ignore",""];
}

function parseWordsSaid(str) {
 
  const words = str.split(" ")

  //console.log("string ",str)
  //console.log("words",words,words.length)
  if (words.length == 0) {
      return ["ignore",""];
  }

  var currentWord = (words.length > 0) ? words[0] : "xyz"
  var nextWord = (words.length > 1) ? words[1] : "xyz"
  var nextNextWord = (words.length > 2) ? words[2] : "xyz"
        
  //console.log("current word",currentWord)

  for (var i = 0; i < words.length; i++) {
      if (currentWord == "ignore") {
          return ["ignore",""];
      }

      if (currentWord == "command") {
        let returnArray = parseCommands(words, i+1)
          return returnArray
      }
      currentWord = nextWord;
      nextWord = nextNextWord;
      nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
  }
  return ["ignore",""]
}

function startTimer() {
    
    function oneSecondInterval() {
      if (timerCanStop ) {
        clearInterval(id)
        return
      }
      timerAmount.value++
    }
    var id = setInterval(oneSecondInterval, 1000)
  }

</script>

<style scoped>

ion-label {
    cursor: pointer;
 }

</style>
